






import { Component, Vue } from "vue-property-decorator";
import { Base64Helper } from "@/utils/base64";

@Component
export default class FileViewer extends Vue {
  public fileUrl: string | null = null;
  public mounted() {
    const file = this.$route.query.id;
    this.fileUrl = file && Base64Helper.fromBase64(`${file}`);
  }
}
